function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  height: fit-content;\n  &.bordered {\n    grid-auto-rows: minmax(10px, auto);\n    .data {\n      border: 1px solid ", ";\n    }\n  }\n  &.list {\n    grid-auto-rows: minmax(3rem, auto);\n    padding: 5px;\n    .data {\n      background-color: ", ";\n      padding: 5px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
var StyledRow = styled.div(_templateObject(), function (props) {
  return props.size;
}, function (props) {
  return props.theme.border;
}, function (props) {
  return props.theme.background;
});

var TableRow = function TableRow(_ref) {
  var rowData = _ref.rowData,
      variant = _ref.variant,
      rest = _objectWithoutPropertiesLoose(_ref, ["rowData", "variant"]);

  return /*#__PURE__*/React.createElement(StyledRow, _extends({
    className: "" + variant,
    size: rowData.length
  }, rest), rowData.map(function (_ref2, index) {
    var Component = _ref2.component,
        propsData = _ref2.propsData;
    return /*#__PURE__*/React.createElement("div", {
      className: "data",
      key: index
    }, /*#__PURE__*/React.createElement(Component, propsData), ' ');
  }));
};

TableRow.propTypes = process.env.NODE_ENV !== "production" ? {
  rowData: PropTypes.array,
  variant: PropTypes.string
} : {};
TableRow.defaultProps = {
  variant: 'bordered',
  rowData: [],
  theme: defaultTheme
};
export default TableRow;